//
// simple wrapper around rollbar
//

import Rollbar from "rollbar";

export let rollbar: Rollbar | undefined;

export function init(options: { accessToken: string; revision?: string }): Rollbar {
  // now setup rollbar
  rollbar = new Rollbar({
    accessToken: options.accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    // codeVersion: options.revision,
    hostSafeList: ["alertmouse.com"], // ignore errors from 3rd party js (eg wistia)
    ignoredMessages: [/\$el\?.getBoundingClientRect is not a function/],
    payload: {
      environment: import.meta.env.MODE,
      client: {
        javascript: {
          // amd - try this instead of top-level codeVersion. I think Rollbar v3 might fix this?
          code_version: options.revision,
          guess_uncaught_frames: true,
          source_map_enabled: true,
        },
      },
    },
  });

  // for testing
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).rollbar = rollbar;

  return rollbar;
}

export function logout() {
  rollbar?.configure({ payload: { person: undefined } });
}

export function error(err: unknown, custom?: Rollbar.LogArgument) {
  // Rollbar.LogArgument = string | Error | object | Dictionary | Callback | Date | any[] | undefined;
  let log: string | Error;
  if (err instanceof Error || isString(err)) {
    log = err;
  } else {
    // https://app.rollbar.com/a/gurgeous/fix/item/alerts/92
    // https://app.rollbar.com/a/gurgeous/fix/item/alerts/111
    log = new Error(`strange err:${Util.getClassName(err)}/${err}/${Util.stringify(err)}`);
    console.error(log);
  }
  rollbar?.error(log, custom);
}

export function warning(msg: string, data?: object) {
  rollbar?.warning(msg, data);
}
